module.exports = require('./helpers/bundle-url').getBundleURL('et4eZ') + "logo.c51670a8.svg";